import React from "react";
import PaymentIntrumentSelection from "../paymentInstrumentSelection/PaymentIntrumentSelection";
import PyamentButton from "../../paymentButton/PaymentButton";
import { getComparator, sortFunction } from "../../../../Utils/utils";

export default function Bnpl({ walletMethodInfo, darkColor, lightColor }) {
  const sortedData = React.useMemo(() => {
    return (
      walletMethodInfo &&
      sortFunction(walletMethodInfo, getComparator("asc", "title"))
    );
  }, [walletMethodInfo]);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      <PaymentIntrumentSelection data={sortedData} />
      <PyamentButton />
    </div>
  );
}
